GatorSurvey.app.directive('gsSurveyLive', ['$timeout', '$mdDialog', '$location', 'surveyResponseService', 'conditionCheckingService', 'recaptchaService', SurveyLive]);

function SurveyLive($timeout, $mdDialog, $location, surveyResponseService, conditionCheckingService, recaptchaService) {
	return {
		require: '?ngModel',
		restrict: 'AE',
		scope: {
			survey: "=?ngModel",
			retakeOptions: "=?",
			retakeHistory: "=?"
		},
		templateUrl: 'Assets/Scripts/App/Directives/Live/Templates/SurveyLive.html',
		controller: ('liveSurvey', ['$scope', '$q', function($scope, $q) {
			var test = $location.search();
			var self = this;
			self.isDynamicPaging = false;
			self.activePageIndex = 0;
			self.dynamicPageNo = 0;
			self.HeadingBack = false;
			$scope.numberOfPages = 0;
			$scope.isSubmit = false;
			$scope.activePage = {};
			$scope.surveyProgress = 0;
			$scope.loading = true;
			$scope.validationMessages = [];
			$scope.surveyCompleted = false;
			$scope.SurveyIdCookieName = "";
            $scope.submitted = false;
			$scope.retakeHistory = {
				lastSurveyCompletedDate: null,
				numberOfRetakes: 0
			};

			var responseId = function () {
				var cookies = document.cookie.split(";");
				var idSplit = GatorSurvey.models.SelectedId().split("-");
				var cookieName = "";

				for (var i = 0; i < idSplit.length; i++) {
					cookieName += idSplit[i];
				}
				if (typeof window.isTest !== "undefined") {
					cookieName += window.isTest !== 0 ? "Test" : "";
				}

				$scope.SurveyIdCookieName = cookieName;

				for (var c = 0; c < cookies.length; c++) {
					if (cookies[c].split("=")[0].toLowerCase().trim() === cookieName.toLowerCase()) {
						var cookieSplit = cookies[c].replace(cookieName + "=", "").split("&");
						for (var ci = 0; ci < cookieSplit.length; ci++) {
							var cookieValue1 = cookieSplit[ci].trim().split("=");
							if (cookieValue1[0] === "Contact") {
								return cookieValue1[1];
							}
						}
					}
				}
				return null;
			};
			function getPage(pageId) {
				for (var p = 0; p < $scope.survey.pages.length; p++) {

					if (getUrlParameter("t") === "1") {
						if ($scope.survey.pages[p].tempId === pageId)
							return $scope.survey.pages[p];

					} else if ($scope.survey.pages[p].id === pageId)
						return $scope.survey.pages[p];


				}
				throw "error - could not find page";
			}
			function getQuestion(page, questionId, questionNumber) {
				for (var q = 0; q < page.elements.length; q++) {
					if (page.elements[q].type === "question") {

						if (getUrlParameter("t") === "1") {
							if (page.elements[q].question.tempId === questionId)
								return page.elements[q].question;
						} else if (page.elements[q].question.id === questionId)
							return page.elements[q].question;

					}
				}
				throw "error - could not find question";
			}
			function checkPageCondtions(pageToCheck) {
				if (pageToCheck.pageType === 1) {
					return true;
				}
				var isNextPage = true;

				if (pageToCheck.userHasConditions || pageToCheck.conditionGroups.length > 0) {
					var conditionGroupsTest = [];
					for (var pcg = 0; pcg < pageToCheck.conditionGroups.length; pcg++) {
						var tests = [];
						var questionNumber = 0;
						var lastNextPart = -1;
						for (var c = 0; c < pageToCheck.conditionGroups[pcg].pageConditions.length; c++) {
							try {
								var isTestingSuvrey = getUrlParameter("t") === "1";
								var condition = pageToCheck.conditionGroups[pcg].pageConditions[c];
								var pageId = isTestingSuvrey ? condition.page.tempId : condition.page.id;
								var page = getPage(pageId);
								var questionId = isTestingSuvrey ? condition.question.tempId : condition.question.id;
								var question = getQuestion(page, questionId, questionNumber);
								var response = surveyResponseService.findResponce(questionId);
								switch (condition.operation) {
									case 0:
										tests.push({ pass: conditionCheckingService.idEquals(question, response, condition.textAnswer), andOr: condition.nextPart });
										break;
									case 1:
										tests.push({ pass: conditionCheckingService.idNotEquals(question, response, condition.textAnswer), andOr: condition.nextPart });
										break;
									case 2:
										tests.push({ pass: conditionCheckingService.isGreaterThan(question, response, condition.textAnswer), andOr: condition.nextPart });
										break;
									case 3:
										tests.push({ pass: conditionCheckingService.isGreaterThanEqual(question, response, condition.textAnswer), andOr: condition.nextPart });
										break;
									case 4:
										tests.push({ pass: conditionCheckingService.isLessThen(question, response, condition.textAnswer), andOr: condition.nextPart });
										break;
									case 5:
										tests.push({ pass: conditionCheckingService.isLessThenEqual(question, response, condition.textAnswer), andOr: condition.nextPart });
										break;
									case 6:
										tests.push({ pass: response !== null, andOr: condition.nextPart });
										break;
									case 7:
										tests.push({ pass: conditionCheckingService.isLike(question, response, condition.textAnswer), andOr: condition.nextPart });
										break;
								}
							} catch (exception) {
								console.dir(exception);
								tests.push({ pass: true, andOr: 0 });
							}
						}
						var passed = false;
						var orFound = false;
						var foundAt = [];
						for (var t = 0; t < tests.length; t++) {
							if (t === 0) {
								passed = tests[t].pass;
							} else {
								if (!tests[t - 1].andOr) {
									passed = passed && tests[t].pass;
								} else {
									orFound = true;
									foundAt.push(t);
								}
							}
						}
						if (orFound) {
							for (var o = 0; o < foundAt.length; o++) {
								if (passed)
									break;
								else {
									passed = tests[foundAt[o]].pass;
								}
							}
						}
						conditionGroupsTest.push({ "passed": passed, "andOr": pageToCheck.conditionGroups[pcg].andOr });
					}
					conditionGroupsTest.sort(function (a, b) { return a.andOr - b.andOr; });
					var groupsPassed = false;
					var nextOperator = false; //false is and. 
					for (var i = 0; i < conditionGroupsTest.length; i++) {
						if (i === 0) {
							groupsPassed = conditionGroupsTest[i].passed;
							nextOperator = conditionGroupsTest[i].andOr;
							continue;
						}

						if (nextOperator) // and 
						{
							groupsPassed = groupsPassed && conditionGroupsTest[i].passed;
							nextOperator = conditionGroupsTest[i].andOr;
							continue;
						}
						groupsPassed = groupsPassed || conditionGroupsTest[i].passed;
						nextOperator = conditionGroupsTest[i].andOr;
						continue;
					}
					isNextPage = groupsPassed;
				} else {
					isNextPage = true;
				}
				return isNextPage;

			}
			function isSubmitCheck() {

				if (self.activePageIndex === $scope.survey.pages.length - 1)
					return true;
				if ($scope.survey.pages[self.activePageIndex + 1].pageType === 1)
					return true;
				if ($scope.activePage.number === 1 && $scope.activePage.pageType !== 0)
					return false;
				//see if any future pages are accessable.
				var submit = 0;
				var countOfRemaingPages = 0;
				angular.forEach($scope.survey.pages, function (page, key) {
					if (page.pageType !== 1 && key > self.activePageIndex) {
						countOfRemaingPages++;
						if (!checkPageCondtions(page)) {
							submit++;
						}
					}
				});
				return submit === countOfRemaingPages;
			}
			function findCompletedPage() {
				surveyResponseService.getAllResponses(GatorSurvey.models.SelectedId()).then(function (response) {
					surveyResponseService.responses = response.responses;
					for (var i = 0; i < $scope.survey.pages.length; i++) {
						self.activePageIndex = i;
						if (isSubmitCheck()) {
							$scope.activePage = $scope.survey.pages[i];
							break;
						}
					}
					$scope.loading = false;
				});
			}
			function getMandatoryQuestionsNotFilledIn(callback) {
				$scope.validationMessages = [];
				$scope.activePage.elements.forEach(function (elm) {
					if (elm.type === "question") {

                        var idToLookAt = getUrlParameter("t") !== "1" ? elm.question.id : elm.question.tempId;

                        if (elm.question.required) {
                            if (!surveyResponseService.responseRequireCheck(idToLookAt, elm.question.type)) {
                                switch (elm.question.type) {
                                    case "email":
                                        $scope.validationMessages.splice($scope.validationMessages.length,
                                            0,
                                            elm.question.text + " - A valid email address is required.");
                                        break;
                                    default:
                                        $scope.validationMessages.splice($scope.validationMessages.length,
                                            0,
                                            elm.question.text + " - Is mandatory.");
                                }
                            }
                        } else {
                            switch (elm.question.type) {
								case "email":
									var response = surveyResponseService.findResponce(idToLookAt);

									if (typeof response.answer === "undefined") //is undefined when validation has failed
                                    {
                                        $scope.validationMessages.splice($scope.validationMessages.length,
                                            0,
                                            elm.question.text + " - A valid email address is required.");
									}
                                    break;
                            }
                        }
					}
				});
				if ($scope.validationMessages.length === 0) {
					callback();
				} else {
					self.showWarningPopup();
				}
			}
			function getReponcesForPage() {
				var reponses = [];
				angular.forEach($scope.activePage.elements, function (elm) {
					if (elm.type === "question") {
						for (var i = 0; i < surveyResponseService.responses.length; i++) {
							if (surveyResponseService.responses[i].id === elm.question.id) {
								reponses.push(surveyResponseService.responses[i]);
							}
						}
					}
				});
				return reponses;
			}
			function defaultSuccessModal() {
				return $mdDialog.alert()
					.clickOutsideToClose(false)
					.title('Survey Completed')
					.textContent('The Survey has been successfully submitted.')
					.ariaLabel('Submission Success Dialog')
					.ok('Ok');
			}
			function defaultAlreadySubmittedModal() {
				return $mdDialog.alert()
					.clickOutsideToClose(false)
					.title('Survey Completed')
					.textContent('You have already submitted your responses for this survey.')
					.ariaLabel('Submission Success Dialog')
					.ok('Ok');
			}
			function defaultSubmissionFailure() {
				return $mdDialog.alert()
					.clickOutsideToClose(false)
					.title('Submission Failure')
					.textContent('Sorry, Something went wrong and we could not submit this survey.')
					.ariaLabel('Submission Failure Dialog')
					.ok('Ok');
			}
			function customSuccessModal() {
				return $mdDialog.alert()
					.clickOutsideToClose(false)
					.title('Survey Completed')
					.textContent($scope.survey.confirmationMessage)
					.ariaLabel('Custom Submission Success Dialog')
					.ok('Ok');
			}

			function setCookie(name, value, options, encrypt) {

				if (options.expires instanceof Date) {
					options.expires = options.expires.toUTCString();
				}
				if (typeof encrypt === "undefined")
					encrypt = true;

				var updatedCookie = "";

				if (encrypt)
					updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
				else
					updatedCookie = name + "=" + value;

				for (var optionKey in options) {
					updatedCookie += "; " + optionKey;
					var optionValue = options[optionKey];
					if (optionValue !== true) {
						updatedCookie += "=" + optionValue;
					}
				}
				document.cookie = updatedCookie;
			}

			function deleteCookie(name) {
				setCookie(name,
					"",
					{
						'max-age': -1,
						'path': '/'
					});
			}

			$scope.hideWarningPopup = function () {
				$mdDialog.hide({
					contentElement: "#warningDialog",
					parent: angular.element(document.body)
				});
			};
			self.showWarningPopup = function () {
				if ($scope.validationMessages && $scope.validationMessages.length !== 0 && $scope.validationMessages[0] !== '') {
					$mdDialog.show({
						contentElement: "#warningDialog",
						parent: angular.element(document.body)
					}).then(function () {
						$scope.hideWarningPopup();
						$scope.loading = false;
					});
				}
			};
			self.LoadPage = function (pageNo, isForwards) {

				$scope.setDynamicPageNumbers(pageNo, isForwards);
				$scope.activePage = $scope.survey.pages[pageNo];
				self.activePageIndex = pageNo;
				$scope.isSubmit = isSubmitCheck();
				$scope.loading = false;
				$scope.surveyProgress = Math.round(((self.activePageIndex + 1) / $scope.survey.pages.length) * 100);
				$('.SurveyContainer.survey-body').scrollTop(0);

			};
			$scope.nextPage = function () {
				if ($scope.activePage.number === 1 && $scope.survey.recaptcha === 1 && !recaptchaService.passed) {
					var cookiedPassed = false;
					var cookies = document.cookie.split(";");
					for (var i = 0; i < cookies.length; i++) {
						if (cookies[i].indexOf("reCaptchaComplete") > -1) {
							cookiedPassed = cookies[i].split("=")[1] === "passed";
						}
					}
					if (!cookiedPassed) {
						$mdDialog.show({
							contentElement: "#recaptchaWarning",
							parent: angular.element(document.body)
						}).then(function () {
							$scope.loading = false;
						});
						return;
					}
				}
				$scope.loading = true;
				getMandatoryQuestionsNotFilledIn(function () {
					var responce = getReponcesForPage();
					surveyResponseService.BuildresponseModal(responseId(), responce, $scope.activePage.id).then(function () {
						for (var i = 0; i < $scope.survey.pages.length; i++) {
							var page = $scope.survey.pages[i];
							if (i > self.activePageIndex) {
								if (checkPageCondtions(page)) {
									self.activePageIndex = i;
									break;
								}
							}
						}
						self.LoadPage(self.activePageIndex, true);
						self.dynamicPageNo++;
						$scope.surveyProgress = Math.round(((self.activePageIndex + 1) / $scope.survey.pages.length) * 100);
					});
				});
			};
			$scope.backPage = function () {
				$scope.loading = true;
				for (var i = $scope.survey.pages.length; i >= 0; i--) {
					var page = $scope.survey.pages[i];
					if (i < self.activePageIndex) {
						if (checkPageCondtions(page)) {
							self.activePageIndex = i;
							break;
						}
					}
				}
				self.LoadPage(self.activePageIndex, false);
				self.dynamicPageNo--;
				$scope.surveyProgress = Math.round(((self.activePageIndex + 1) / $scope.survey.pages.length) * 100);
			};
			$scope.submitPage = function () {
                $scope.submitted = true;

				if ($scope.isSubmit && $scope.survey.recaptcha === 2 && !recaptchaService.passed) {

					var cookiedPassed = false;
					var cookies = document.cookie.split(";");
					for (var i = 0; i < cookies.length; i++) {
						if (cookies[i].indexOf("reCaptchaComplete") > -1) {
							cookiedPassed = cookies[i].split("=")[1] === "passed";
						}
					}
					if (!cookiedPassed) {
						$mdDialog.show({
							contentElement: "#recaptchaWarning",
							parent: angular.element(document.body)
						}).then(function () {
							$scope.loading = false;
						});
						return;
					}
				}
				$scope.loading = true;
				$timeout(function () {
					getMandatoryQuestionsNotFilledIn(function () {
						var responce = getReponcesForPage();
						console.log(responce);
						surveyResponseService.BuildresponseModal(responseId(), responce, $scope.activePage.id).then(function (data) {
							surveyResponseService.retakeHistory(responseId()).then(function (history) {
								$scope.retakeHistory.lastSurveyCompletedDate = history.lastSurveyCompletedDate;
								var customDialog = null;
                                $scope.survey.completed = true;
                                if (data !== "Submitted") {
									if (typeof window.isTest !== "undefined") {
										if (window.isTest === 0) {
											surveyResponseService.CompleteSurvey($scope.survey.publishVersion).then(function () {
													if ($scope.retakeOptions.saveState)
														surveyResponseService.retakeHistory(responseId()).then(function (rHData) {
																$scope.retakeHistory.lastSurveyCompletedDate = rHData.lastSurveyCompletedDate;
															});
													else {
														deleteCookie($scope.SurveyIdCookieName);
													}
												});
										}
									} else {
										surveyResponseService.CompleteSurvey($scope.survey.publishVersion);
										if ($scope.retakeOptions.saveState)
											surveyResponseService.retakeHistory(responseId()).then(function (rHData) {
													$scope.retakeHistory.lastSurveyCompletedDate = rHData.lastSurveyCompletedDate;
												});
										else {
											deleteCookie($scope.SurveyIdCookieName);	
										}


									}
									var count = $scope.survey.pages.length;
									if ($scope.survey.pages[count - 1].pageType === 1) {
										self.activePageIndex = count - 1;
										self.LoadPage(self.activePageIndex, null);
										if ($scope.survey.confirmationType.toString() === "1") {
											$timeout(function () {
												var url = $scope.survey.redirectUrl;
												if (url.indexOf("http") === -1) {
													url = "http://" + url;
												}
												window.location.href = url;
											}, 10000);
										}
									} else {
										if ($scope.survey.confirmationType !== 0) {
											switch ($scope.survey.confirmationType.toString()) {
												case "1":
													$timeout(function () {
														var url = $scope.survey.redirectUrl;
														if (url.indexOf("http") === -1) {
															url = "http://" + url;
														}
														window.location.href = url;

													}, 300);
													break;
												default:

													if ($scope.survey.confirmationMessage !== null && $scope.survey.confirmationMessage !== "") {
														customDialog = customSuccessModal();

													} else {
														customDialog = defaultSuccessModal();
													}
													$mdDialog.show(customDialog).then(function () {
														$scope.loading = false;
													});
													break;
											}
										} else {
											customDialog = defaultSuccessModal();
											$mdDialog.show(customDialog).then(function () {
												$scope.loading = false;
											});

										}
									}
								} else {
									if ($scope.survey.confirmationType !== 0) {
										switch ($scope.survey.confirmationType.toString()) {
											case "1":
												$timeout(function () {
													var url = $scope.survey.redirectUrl;
													if (url.indexOf("http") === -1) {
														url = "http://" + url;
													}
													window.location.href = url;
												}, 300);
												break;
											default:
												customDialog = defaultAlreadySubmittedModal();
												$mdDialog.show(customDialog).then(function () {
													$scope.loading = false;
												});
												break;
										}
									} else {
										customDialog = defaultAlreadySubmittedModal();
										$mdDialog.show(customDialog).then(function () {
											$scope.loading = false;
										});
									}
								}
							});
						}, function () {
							var failureDialog = defaultSubmissionFailure();
							$mdDialog.show(failureDialog).then(function () {
								$scope.loading = false;
							});
						});
					});
				});
			};
			$scope.isAllowedRetake = function () {
				
				if ($scope.retakeOptions.saveState === false)
					return false;
				//retake = one submition
				if ($scope.retakeOptions.retakeAllowedType === 0)
					return false;
				//retake = standard multiple
				if ($scope.retakeOptions.retakeAllowedType === 1)
					return true;
				if ($scope.retakeOptions.retakeAllowedType === 2) {

					if ($scope.retakeHistory.lastSurveyCompletedDate == null)
						return false;

					if ($scope.retakeOptions.advanced.type === 0)
						return $scope.retakeHistory.numberOfRetakes < $scope.retakeOptions.advanced.maxAllowed;

					var lastSubmitted;
					var today;

					if ($scope.retakeOptions.advanced.type === 1) {
						lastSubmitted = new moment($scope.retakeHistory.lastSurveyCompletedDate);
						today = new moment();
						if (today.diff(lastSubmitted, 'days') === 0)
							return false;
						else
							switch (today.isoWeekday()) {
								case 1:
									return $scope.retakeOptions.advanced.retakeAllowedDays.monday;
								case 2:
									return $scope.retakeOptions.advanced.retakeAllowedDays.tuesday;
								case 3:
									return $scope.retakeOptions.advanced.retakeAllowedDays.wednesday;
								case 4:
									return $scope.retakeOptions.advanced.retakeAllowedDays.thursday;
								case 5:
									return $scope.retakeOptions.advanced.retakeAllowedDays.friday;
								case 6:
									return $scope.retakeOptions.advanced.retakeAllowedDays.saturday;
								case 7:
									return $scope.retakeOptions.advanced.retakeAllowedDays.sunday;
							}
					}

					if ($scope.retakeOptions.advanced.type === 2) {
						switch ($scope.retakeOptions.advanced.resetType) {
							case "Day":
								lastSubmitted = new moment($scope.retakeHistory.lastSurveyCompletedDate);
								today = new moment();
								return today.diff(lastSubmitted, 'days') >= $scope.retakeOptions.advanced.resetPeriod;
							case "Week":
								lastSubmitted = new moment($scope.retakeHistory.lastSurveyCompletedDate);
								today = new moment();
								return today.diff(lastSubmitted, 'weeks') >= $scope.retakeOptions.advanced.resetPeriod;
							case "Month":
								lastSubmitted = new moment($scope.retakeHistory.lastSurveyCompletedDate);
								today = new moment();
								return today.diff(lastSubmitted, 'months') >= $scope.retakeOptions.advanced.resetPeriod;
							default:
						}
					}

				}
			};
			$scope.retakeSurvey = function () {
				surveyResponseService.retakeSurvey(responseId()).then(function (data) {
					console.log(getCookie($scope.SurveyIdCookieName));
					var expire = new moment();
					var date = expire.add(30, 'minutes').format("ddd, DD MMM YYYY HH:MM:SS UTC");
					var expired = {
						'expires': date
					};
					setCookie("reCaptchaComplete", (recaptchaService.passed ? "passed" : "nope"), expired,false);
					setCookie($scope.SurveyIdCookieName, data,expired,false);
					window.location.reload();
				});
			};
			function getCookie(cname) {
				var name = cname + "=";
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			}
			$scope.setDynamicPageNumbers = function (pageNo, isForwards) {

				var newPage = $scope.survey.pages[pageNo];
				var oldPage;

				if ($scope.survey.latestQstNo === undefined) {
					$scope.survey.latestQstNo = 0;
				}

				if (isForwards === null) {//if we starting at beginning of questions.

					angular.forEach(newPage.elements, function (elem, key) {

						if (elem.question && $scope.survey.dynamicQuestionNumbers) {
							$scope.survey.latestQstNo++;

							if ($scope.survey.numberPrefix === null)
								$scope.survey.numberPrefix = "";

							if ($scope.survey.numberSufix === null)
								$scope.survey.numberSufix = "";

							elem.question.questionNumber = $scope.survey.numberPrefix + $scope.survey.latestQstNo + $scope.survey.numberSufix;
						}

					});

				} else if (isForwards) {//if we're going forwards add the page numbers to "lastPageQstnNo"

					oldPage = $scope.survey.pages[pageNo + 1];

					angular.forEach(newPage.elements, function (elem, key) {
						if (elem.question && $scope.survey.dynamicQuestionNumbers) {
							$scope.survey.latestQstNo++;

							if ($scope.survey.numberPrefix === null)
								$scope.survey.numberPrefix = "";

							if ($scope.survey.numberSufix === null)
								$scope.survey.numberSufix = "";

							elem.question.questionNumber = $scope.survey.numberPrefix + $scope.survey.latestQstNo + $scope.survey.numberSufix;
						}
					});

				} else {//otherwise we're going back and need to minus from "lastPageQstnNo"

					var totalQuestions = 0;
					oldPage = $scope.survey.pages[pageNo + 1];

					oldPage.elements.slice().reverse().forEach(function (elem, key) {
						if (elem.question && $scope.survey.dynamicQuestionNumbers) {

							if ($scope.survey.numberPrefix === null)
								$scope.survey.numberPrefix = "";

							if ($scope.survey.numberSufix === null)
								$scope.survey.numberSufix = "";

							$scope.survey.latestQstNo--;
						}
					});

					newPage.elements.slice().reverse().forEach(function (elem, key) {

						if (elem.question && $scope.survey.dynamicQuestionNumbers) {
							totalQuestions++;

							if ($scope.survey.numberPrefix === null)
								$scope.survey.numberPrefix = "";

							if ($scope.survey.numberSufix === null)
								$scope.survey.numberSufix = "";

							$scope.survey.latestQstNo--;

							elem.question.questionNumber = $scope.survey.numberPrefix + ($scope.survey.latestQstNo + 1).toString() + $scope.survey.numberSufix;
						}

					});

					$scope.survey.latestQstNo = ($scope.survey.latestQstNo + totalQuestions);//re-add all questions removed so we know where we are.

				}
			};
			$scope.$watch('survey', function () {
				if (typeof $scope.survey.pages !== "undefined") {
					var count = $scope.survey.pages.length;
					if ($scope.survey.pages[count - 1].pageType === 1) {
						self.numberOfPages = count - 1;
					} else {
						self.numberOfPages = count;
					}
					if ($scope.survey.completed === true) {
						if ($scope.survey.pages[$scope.survey.pages.length - 1].pageType === 0) {
							findCompletedPage();
							$scope.isSubmit = true;
						}
						else {
							self.LoadPage($scope.survey.pages.length - 1, null);

						}
					} else {
						self.LoadPage(0, null);
					}
				}
			});
			surveyResponseService.updateNextSubmit = function () {
				$timeout(function () {
					$scope.isSubmit = isSubmitCheck();
					$.apply();
				});
			};
		}
		])
	};
}
